import { AlignLeft, Image as ImageIcon, Link as LinkIcon, Loader2, Type, Video } from 'lucide-react';
import React, { useEffect, useState } from 'react';
import { supabase } from '../../supabaseClient'; 
import { styles } from '../../styles'; 


export function EpisodePublisher() {
  const [parentVideos, setParentVideos] = useState<any[]>([]); 
  const [selectedSeriesId, setSelectedSeriesId] = useState(''); 
  const [seasonNumber, setSeasonNumber] = useState('1'); 
  const [episodeNumber, setEpisodeNumber] = useState('1'); 
  const [episodeDuration, setEpisodeDuration] = useState(''); 

  const [videoUrl, setVideoUrl] = useState(''); 
  const [thumbFile, setThumbFile] = useState<File | null>(null);
  const [thumbUrl, setThumbUrl] = useState(''); 
  const [title, setTitle] = useState('');
  const [description, setDescription] = useState('');
  
  const [loading, setLoading] = useState(false);
  const [previewThumb, setPreviewThumb] = useState('');

  // 📡 BUSCA AS SÉRIES E CANAIS (Filmes Mães)
  useEffect(() => {
    const fetchSeriesAndChannels = async () => {
      const { data, error } = await supabase
        .from('videos')
        .select('id, title, category')
        .in('category', ['serie', 'canais']); 
      
      if (!error && data) {
        setParentVideos(data);
        if (data.length > 0) setSelectedSeriesId(data[0].id);
      }
    };
    fetchSeriesAndChannels();
  }, []);

  // 🪄 IA GEMINI (Opcional para Títulos de Episódios)
  const handleGeminiMagic = async () => {
    if (!title) return alert("Digite o assunto/resumo primeiro!");
    setLoading(true);
    const API_KEY = process.env.REACT_APP_GEMINI_API_KEY;
    try {
      const URL = `https://generativelanguage.googleapis.com/v1beta/models/gemini-1.5-pro:generateContent?key=${API_KEY}`;
      const response = await fetch(URL, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          contents: [{ parts: [{ text: `Melhore este título e crie uma sinopse curta para um episódio de série: "${title}". Formato JSON: {"novoTitulo": "", "sinopse": ""}` }] }]
        })
      });
      const result = await response.json();
      if (result.error) throw new Error(result.error.message);
      const text = result.candidates[0].content.parts[0].text;
      const jsonMatch = text.match(/\{[\s\S]*\}/);
      if (jsonMatch) {
        const data = JSON.parse(jsonMatch[0]);
        setTitle(data.novoTitulo);
        setDescription(data.sinopse);
      }
    } catch (err: any) {
      alert("IA diz: " + err.message);
    } finally {
      setLoading(false);
    }
  };

  // 🖼️ LÓGICA DE PRÉVIA
  useEffect(() => {
    const extrairIdUniversal = (url: string) => {
      if (!url) return null;
      const ytRegex = /(?:youtube\.com\/(?:[^\/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/|youtube\.com\/shorts\/)([^"&?\/\s]{11})/;
      const match = url.match(ytRegex);
      if (match && match[1]) return match[1];
      return null;
    };

    if (thumbFile) {
      const url = URL.createObjectURL(thumbFile);
      setPreviewThumb(url);
      return () => URL.revokeObjectURL(url);
    } else if (thumbUrl) {
      setPreviewThumb(thumbUrl);
    } else {
      const idFinal = extrairIdUniversal(videoUrl);
      if (idFinal) setPreviewThumb(`https://img.youtube.com/vi/${idFinal}/maxresdefault.jpg`);
      else setPreviewThumb('');
    }
  }, [thumbFile, thumbUrl, videoUrl]);

  // 🚀 LÓGICA DE PUBLICAÇÃO (Exclusiva Episódios)
  const handlePublishEpisode = async () => {
    if (!title || !selectedSeriesId) return alert("Verifique o título e se uma série foi selecionada!");
    setLoading(true);

    const extrairIdYoutube = (url: string) => {
      if (!url) return null;
      const ytRegex = /(?:youtube\.com\/(?:[^\/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/|youtube\.com\/shorts\/)([^"&?\/\s]{11})/;
      const match = url.match(ytRegex);
      if (match && match[1]) return match[1];
      return null;
    };

    try {
      let finalThumbUrl = thumbUrl || previewThumb;
      const embedId = extrairIdYoutube(videoUrl);

      if (thumbFile) {
        const fileExt = thumbFile.name.split('.').pop();
        const fileName = `ep_${Math.random()}.${fileExt}`;
        const { error: uploadError } = await supabase.storage.from('videos_feed').upload(fileName, thumbFile);
        if (!uploadError) {
          const { data } = supabase.storage.from('videos_feed').getPublicUrl(fileName);
          finalThumbUrl = data.publicUrl;
        }
      }

      // 💥 INSERE NA TABELA DE EPISÓDIOS
      const { error: epError } = await supabase.from('episodes').insert([{
        series_id: selectedSeriesId,
        title: title,
        description: description,
        duration: episodeDuration || '45min',
        thumbnail: finalThumbUrl,
        season: parseInt(seasonNumber) || 1,
        episode_number: parseInt(episodeNumber) || 1,
        video_url: videoUrl,
        embed_id: embedId
      }]);

      if (epError) throw epError;
      
      alert("🍿 SUCESSO! Episódio adicionado ao Hub!");
      
      setEpisodeNumber(String(parseInt(episodeNumber) + 1)); 
      setVideoUrl(''); setThumbUrl(''); setThumbFile(null); setTitle(''); setDescription(''); setEpisodeDuration('');
      
    } catch (err: any) {
      alert("Erro: " + err.message);
    } finally {
      setLoading(false);
    }
  };

  const extrairIdYoutubePlayer = (url: string) => {
    if (!url) return null;
    const ytRegex = /(?:youtube\.com\/(?:[^\/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/|youtube\.com\/shorts\/)([^"&?\/\s]{11})/;
    const match = url.match(ytRegex);
    return (match && match[1]) ? match[1] : null;
  };

  const youtubeId = extrairIdYoutubePlayer(videoUrl);

  return (
    <div>
      <style>{`
        .episode-publisher-layout {
          display: grid;
          grid-template-columns: 1fr 380px;
          gap: 30px;
          width: 100%;
          box-sizing: border-box;
        }
        .episode-form-inner {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 20px;
        }
        @media (max-width: 768px) {
          .episode-publisher-layout {
            display: flex;
            flex-direction: column-reverse;
            gap: 15px;
          }
          .episode-form-inner {
            display: flex;
            flex-direction: column;
            gap: 15px;
          }
        }
      `}</style>

      <div className="episode-publisher-layout">
        <div style={styles.formCard}>
          <h2 style={{ color: '#eab308', marginBottom: 20, display: 'flex', alignItems: 'center', gap: 10, fontSize: '18px' }}>
            <Video size={22} /> Adicionar Novo Episódio
          </h2>

          <div className="episode-form-inner">
            {/* COLUNA ESQUERDA */}
            <div style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
              
              <div style={styles.inputGroup}>
                <label style={{...styles.label, color: '#eab308'}}><Video size={14}/> Vincular à Série/Canal Mãe</label>
                <select 
                  style={{...styles.input, borderColor: '#eab308', backgroundColor: '#000', color: '#fff', height: 40, borderRadius: 8}} 
                  value={selectedSeriesId} 
                  onChange={e => setSelectedSeriesId(e.target.value)}
                >
                  {parentVideos.map((video: any) => (
                    <option key={video.id} value={video.id} style={{backgroundColor: '#111'}}>
                      {video.category === 'canais' ? '📺 [CANAL] ' : '🎬 [SÉRIE] '} {video.title}
                    </option>
                  ))}
                </select>
              </div>

              <div style={styles.inputGroup}>
                <label style={styles.label}><LinkIcon size={14}/> Link do Vídeo</label>
                <input style={styles.input} value={videoUrl} onChange={e => setVideoUrl(e.target.value)} placeholder="YouTube ou MP4" />
              </div>

              <div style={styles.inputGroup}>
                <label style={styles.label}><ImageIcon size={14}/> Capa do Episódio (Opcional)</label>
                <input type="file" accept="image/*" onChange={e => setThumbFile(e.target.files?.[0] || null)} style={{...styles.input, marginBottom: 5}} />
                <input style={styles.input} value={thumbUrl} onChange={e => setThumbUrl(e.target.value)} placeholder="Ou cole o link..." />
              </div>
            </div>

            {/* COLUNA DIREITA */}
            <div style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
              
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px' }}>
                <div style={styles.inputGroup}>
                  <label style={styles.label}>Temporada</label>
                  <input type="number" style={styles.input} value={seasonNumber} onChange={e => setSeasonNumber(e.target.value)} placeholder="Ex: 1" />
                </div>
                <div style={styles.inputGroup}>
                  <label style={styles.label}>Nº Episódio</label>
                  <input type="number" style={styles.input} value={episodeNumber} onChange={e => setEpisodeNumber(e.target.value)} placeholder="Ex: 1" />
                </div>
              </div>

              <div style={styles.inputGroup}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <label style={styles.label}>Título do Episódio</label>
                  <button type="button" onClick={handleGeminiMagic} style={{ backgroundColor: '#6200ee', color: '#fff', border: 'none', borderRadius: 4, padding: '2px 8px', fontSize: 10, cursor: 'pointer' }}>
                    🪄 IA
                  </button>
                </div>
                <input style={styles.input} value={title} onChange={e => setTitle(e.target.value)} placeholder="Ex: O Começo de Tudo" />
              </div>

              <div style={styles.inputGroup}>
                <label style={styles.label}>Duração do Episódio</label>
                <input style={styles.input} value={episodeDuration} onChange={e => setEpisodeDuration(e.target.value)} placeholder="Ex: 45min" />
              </div>
            </div>
          </div>

          <div style={{ ...styles.inputGroup, marginTop: 15 }}>
            <label style={styles.label}><AlignLeft size={14}/> Sinopse do Episódio</label>
            <textarea style={{...styles.input, height: 60, resize: 'none'}} value={description} onChange={e => setDescription(e.target.value)} />
          </div>

          <button type="button" onClick={handlePublishEpisode} disabled={loading} style={{...styles.btnPublish, marginTop: 20, backgroundColor: '#eab308', color: '#000', width: '100%'}}>
            {loading ? <Loader2 className="animate-spin" /> : 'ADICIONAR EPISÓDIO'}
          </button>
        </div>

        {/* PRÉVIA 16:9 COM PLAYER INTERATIVO */}
        <aside style={{ backgroundColor: '#111', padding: 20, borderRadius: 20, border: '1px solid #222', textAlign: 'center', height: 'fit-content' }}>
          <h3 style={{ color: '#fff', marginBottom: 20, fontSize: 16 }}>PRÉVIA: EPISÓDIO</h3>
          <div style={{ width: '100%', aspectRatio: '16/9', backgroundColor: '#000', margin: '0 auto', borderRadius: 10, border: '2px solid #333', overflow: 'hidden', position: 'relative' }}>
            {youtubeId ? (
              <iframe
                src={`https://www.youtube.com/embed/${youtubeId}?autoplay=1`}
                title="Player Preview"
                style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', border: 'none' }}
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              />
            ) : previewThumb ? (
              <img src={previewThumb} style={{ width: '100%', height: '100%', objectFit: 'cover' }} alt="Preview" />
            ) : (
              <div style={{ width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <ImageIcon color="#222" size={40} />
              </div>
            )}
            <div style={{ position: 'absolute', bottom: 0, width: '100%', padding: 10, background: 'linear-gradient(transparent, #000)', boxSizing: 'border-box', pointerEvents: 'none' }}>
              <p style={{ color: '#fff', fontSize: 10, textAlign: 'left', fontWeight: 'bold', margin: 0, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{title || 'Título do Episódio'}</p>
              <p style={{ color: '#eab308', fontSize: 8, textAlign: 'left', margin: '2px 0 0 0' }}>T{seasonNumber} E{episodeNumber}</p>
            </div>
          </div>
        </aside>
      </div>
    </div>
  );
}